import { useNavigate, useLocation } from 'react-router-dom';

export function useUpsellHistory() {
  const navigate = useNavigate();
  const location = useLocation();

  return {
    push: (path, state) =>
      navigate(`/upsell${path}`, { state }),
    replace: (path, state) =>
      navigate(`/upsell${path}`, { replace: true, state }),
    location,
    back: () => navigate(-1),
    forward: () => navigate(1),
  };
}


